import { selectFromPlanningActionDto } from '../../models';

export default selectFromPlanningActionDto()
  .actionUuid
  .actionName
  .status
  .toString();
